/**
 * Header — monta o seletor de idioma (a11y: radiogroup com keyboard nav).
 */
import { setLang, getLang, getAvailableLangs, onLangChange } from '@/i18n/index.js';

/**
 * Renderiza o lang picker dentro do container. Idempotente.
 * @param {HTMLElement} container
 */
export function mountLangPicker(container) {
  if (!container) return;
  if (container.dataset.mounted === 'lang-picker') return;
  container.dataset.mounted = 'lang-picker';
  container.setAttribute('role', 'radiogroup');
  container.setAttribute('aria-label', 'Language');

  const langs = getAvailableLangs();

  for (const { code, short } of langs) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lang-pill';
    btn.setAttribute('role', 'radio');
    btn.dataset.lang = code;
    btn.tabIndex = -1;
    btn.textContent = short;
    btn.setAttribute('aria-checked', getLang() === code ? 'true' : 'false');
    container.appendChild(btn);
  }

  // Foco: pílula ativa começa tabIndex=0, outras -1
  updateTabIndex(container);

  container.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-lang]');
    if (!btn) return;
    setLang(btn.dataset.lang);
  });

  container.addEventListener('keydown', (e) => {
    const pills = [...container.querySelectorAll('[data-lang]')];
    const currentIdx = pills.findIndex((p) => p.getAttribute('aria-checked') === 'true');
    if (currentIdx === -1) return;

    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      const next = pills[(currentIdx + 1) % pills.length];
      next.focus();
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      const prev = pills[(currentIdx - 1 + pills.length) % pills.length];
      prev.focus();
    } else if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      const focused = document.activeElement;
      if (focused && focused.dataset.lang) {
        setLang(focused.dataset.lang);
      }
    }
  });

  // Atualiza aria-checked quando lang muda
  onLangChange((lang) => {
    for (const btn of container.querySelectorAll('[data-lang]')) {
      btn.setAttribute('aria-checked', btn.dataset.lang === lang ? 'true' : 'false');
    }
    updateTabIndex(container);
  });
}

function updateTabIndex(container) {
  const pills = container.querySelectorAll('[data-lang]');
  let firstSet = false;
  for (const btn of pills) {
    if (btn.getAttribute('aria-checked') === 'true') {
      btn.tabIndex = 0;
      firstSet = true;
    } else {
      btn.tabIndex = -1;
    }
  }
  if (!firstSet && pills.length > 0) {
    pills[0].tabIndex = 0;
  }
}
